<template>
  <SendEmailRP/>
</template>

<script>
import SendEmailRP from "@/components/auth/SendEmailResetPass";
export default {
 components:{
     SendEmailRP: SendEmailRP,
 }
}
</script>

<style>

</style>